import styles from './OngoingSessionDetails.module.css'
import { IFText } from 'Components'
import { Colors } from 'Theme'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import PropTypes from 'prop-types'
import { formatDate } from '../../Utils/StringFunctions'
const currencyCodes = require('iso4217')

const OngoingSessionDetails = ({ row }) => {
  const getTimeBetweenDates = (firstDate, secondDate) => {
    var firstMomentDate = moment(firstDate)
    var secondMomentDate = moment(secondDate)
    var chargingTimeInMinutes = secondMomentDate.diff(firstMomentDate, 'm')
    return (
      Math.floor(chargingTimeInMinutes / 60) +
      'h' +
      ' ' +
      (chargingTimeInMinutes % 60) +
      'm'
    )
  }
  const { t } = useTranslation()
  const duration = getTimeBetweenDates(
    row.original.startedAt,
    row.original.updatedAt,
  )
  const connector = row.original.stationInfo?.[0]?.evses?.connectors
  const currency = Object.values(currencyCodes).find(
    (currency) => currency.Code === row.original.currency,
  )
  const ChargingSessionDetailItems = [
    {
      key: 'Name',
      value: row.original.stationInfo?.[0]?.name,
      translationKey: 'TransactionDetails.Name',
    },
    {
      key: 'Start',
      value: formatDate(row.original.startedAt),
      translationKey: 'TransactionDetails.Start',
    },
    {
      key: 'End',
      value: formatDate(row.original.updatedAt),
      translationKey: 'TransactionDetails.End',
    },
    {
      key: 'Duration',
      value: duration,
      translationKey: 'TransactionDetails.Duration',
    },
    {
      key: 'Amount',
      value: `-${row.original.currency} ${Number(
        row.original.totalCost?.inclVat || 0,
      ).toFixed(currency?.Fraction || 2)}`,
      translationKey: 'TransactionDetails.Amount',
    },
    {
      key: 'Consumption',
      value: row.original.energyConsumption ?? '-',
      translationKey: 'TransactionDetails.Consumption',
    },
    {
      key: 'Tariff',
      value: row.original.tariff || '-',
      translationKey: 'TransactionDetails.Tariff',
    },
    {
      key: 'ChargerType',
      value: connector?.type === 'DC' ? 'DC' : 'AC',
      translationKey: 'TransactionDetails.ChargerType',
    },
    {
      key: 'EvseID',
      value: row.original?.evseUid ?? '-',
      translationKey: 'TransactionDetails.EvseID',
    },
    {
      key: 'TokenType',
      value: row.original.chargingToken?.type ?? '-',
      translationKey: 'TransactionDetails.TokenType',
    },
    {
      key: 'TokenID',
      value: row.original.chargingToken?.uid || '-',
      translationKey: 'TransactionDetails.TokenID',
    },
  ]

  return (
    <div
      className={styles.TransactionDetails}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.Line}>
        <div
          style={{ borderLeft: `1px solid ${Colors.DividerColor}` }}
          className={styles.Divider}
        />
        <div
          style={{ background: Colors.DividerColor }}
          className={styles.Circle}
        />
      </div>
      <div className={styles.Details}>
        <div className={styles.ChargingSessionDetails}>
          <IFText className={styles.TransactionTitle}>
            {t('TransactionDetails.CharginSessionTitle')}
          </IFText>
          <div className={styles.AllDetails}>
            {ChargingSessionDetailItems.map((item) => (
              <div className={styles.Detail} key={item.key}>
                <div className={styles.LabelTitle}>
                  <IFText
                    className={styles.DetailText}
                    style={{ color: Colors.DetailPanel }}
                  >
                    {t(item.translationKey)}
                  </IFText>
                </div>
                <div className={styles.LabelValue}>
                  <IFText className={styles.DetailText}>{item.value}</IFText>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
OngoingSessionDetails.propTypes = {
  row: PropTypes.object,
}

export default OngoingSessionDetails
